import * as React from "react";
import Lottie from 'react-lottie';
import { Link } from "gatsby";
import * as animationData from "./data.json";
import "./hero.scss";
import { handleLineBreaks } from "../helpers/prismicHelpers";
export var Hero = function Hero(_ref) {
  var data = _ref.data,
      className = _ref.className,
      showAnimation = _ref.showAnimation;
  var defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };
  var style = data.primary.background_image ? {
    backgroundImage: "url('" + (data.primary.background_image ? data.primary.background_image["url"] : null) + "')"
  } : {};
  var imageCopyright = data.primary.background_image && data.primary.background_image["copyright"];
  return /*#__PURE__*/React.createElement("div", {
    className: "hero " + className + (data.primary.background_image ? ' full-bleed-bg' : ''),
    style: style
  }, imageCopyright && /*#__PURE__*/React.createElement("p", {
    className: "image-copyright"
  }, imageCopyright), showAnimation && /*#__PURE__*/React.createElement("div", {
    className: "animation"
  }, /*#__PURE__*/React.createElement(Lottie, {
    options: defaultOptions,
    height: "100%",
    width: "100%"
  })), /*#__PURE__*/React.createElement("div", {
    className: "fixed-width"
  }, !!data.primary.subheader && /*#__PURE__*/React.createElement("h4", null, handleLineBreaks(data.primary.subheader)), /*#__PURE__*/React.createElement("h1", null, handleLineBreaks(data.primary.main_header)), /*#__PURE__*/React.createElement("p", null, handleLineBreaks(data.primary.content_copy)), data.fields.map(function (a) {
    if (a.action) {
      return /*#__PURE__*/React.createElement(Link, {
        className: "btn",
        to: a.path
      }, a.action);
    }
  })));
};